/* eslint-disable no-shadow */

enum EnumProductUserGroup {
  Internal = 'Internal',
  External = 'External',
}

export default EnumProductUserGroup;
